import type { ListItemButtonProps } from '@mui/material';
import MuiListItemButton from '@mui/material/ListItemButton';
import { forwardRef } from 'react';

const ListItemButton = forwardRef<HTMLDivElement, ListItemButtonProps>(
  (props, ref) => {
    return <MuiListItemButton ref={ref} {...props} />;
  },
);
export default ListItemButton;
